import api from './api';

export const fetchDestinationPackages = () => {
    return api.get('/packages/destination');
  };

export const getPackageById = (id) => api.get(`/packages/destination/${id}`);

